import PageContainer from './PageContainer.vue';

export default PageContainer;
